import React from 'react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
export function StorySection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-295" data-mp="gz4ut1mjlfdz">
      <div className="mx-auto max-w-2xl" data-id="element-296" data-mp="c13723e68rw6">
        <SectionHeading title={<>
              From a technician who doesn't know where to start… to one with a{' '}
              <span className="text-electric-600" data-id="element-298" data-mp="14qsd4v5qni4n">clear diagnostic process</span>
            </>} data-id="element-297" data-mp="c1uw0vd9jrdh" />
        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-muted" data-id="element-299" data-mp="zqxneuxp8yl6">
          <p className="text-lg font-semibold text-ink" data-id="element-300" data-mp="vpc2qnexbg0f">
            When an unfamiliar Transmission Control Module arrives at your workbench, do you immediately know what
            information to collect, what to check first, and what your next step should be?
          </p>
          <p data-id="element-301" data-mp="3gdgmn9pehguq">That's the problem I wanted to solve.</p>
          <p data-id="element-302" data-mp="3bfx6u5d20w0o">
            I've seen how easy it is to accumulate diagnostic tools, saved files, technical manuals, and online
            tutorials without having a consistent process for using that information.
          </p>
          <p data-id="element-303" data-mp="1t5znp6rmeqoy">
            That's why I created <strong className="text-ink" data-id="element-304" data-mp="1f79rrugjex26">TCM Diagnostic Blueprint™</strong>. Instead of giving you
            another massive course to study, I wanted to build something you could open whenever a TCM job presents a
            challenge.
          </p>
          <p data-id="element-305" data-mp="15fn6t6eedjm8">
            A practical visual system to help you organize the diagnostic process, evaluate the information available,
            and make more structured decisions.
          </p>
        </div>
        <blockquote className="mt-8 border-l-4 border-electric-500 bg-canvas py-5 pl-5 pr-4 font-display text-[26px] font-bold uppercase leading-tight text-ink" data-id="element-306" data-mp="wicxhql544jy">
          Spend less time wondering where to start and more time working through a logical diagnostic process.
        </blockquote>
        <CtaButton label="I want a clear starting point for every TCM" className="mt-10" data-id="element-307" data-mp="rgnki5ecxgt8" />
      </div>
    </section>;
}